import React from 'react'
import { MDBRow, MDBCol } from 'mdbreact'
import { GatsbyImage } from 'gatsby-plugin-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import CustomLink from './CustomLink'
import Showdown from 'showdown'

class ColumnAlternatingButton extends React.Component {
  render() {
    const Heading = (this.props.headingLevel && Number.isInteger(this.props.headingLevel)) ? `h${this.props.headingLevel}` : 'h3'
    const SubHeading = (this.props.headingLevel && Number.isInteger(this.props.headingLevel)) ? `h${this.props.headingLevel+1}` : 'h4'
    const converter = new Showdown.Converter()
    return (
      <>
        <MDBRow className={`${this.props.link === null ? 'about-item' : ''} align-items-center pb-3 ${this.props.placement === 'right' ? 'flex-row-reverse' : '' }`} >
          <MDBCol lg={this.props.imageCol ? this.props.imageCol : '6'} className="px-5" >
            {this.props.link ? (
              <CustomLink link={this.props.link}>
                <GatsbyImage image={this.props.image} alt={this.props.alt} className={this.props.imageClass ? this.props.imageClass : 'rounded'} />
              </CustomLink>
            ) : (
              <GatsbyImage image={this.props.image} alt={this.props.alt} className={this.props.imageClass ? this.props.imageClass : 'rounded'} />
            )}
          </MDBCol>
          <MDBCol lg={this.props.textCol ? this.props.textCol : '6'} className="mt-4 mt-lg-0 mb-4 mb-lg-0" >
            <Heading className={ this.props.titleClass != null ? this.props.titleClass : 'font-alt font-w-400 letter-spacing-1 mb-3 title-xs-medium title-medium' } >
              {this.props.title}
            </Heading>
            {(this.props.subtitle != null && this.props.subtitle != "") && (
              <SubHeading className={ this.props.subtitleClass != null ? this.props.subtitleClass : `font-alt font-w-700 letter-spacing-1 mb-4 title-xs-medium title-medium ${this.props.subtitlecolour}` } >
                {this.props.subtitle}
              </SubHeading>
            )}
            <div
              className="mt-3 mb-3 font-w-400 text-medium divlink"
              dangerouslySetInnerHTML={{ __html: converter.makeHtml(this.props.description) }}
            />
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol>
            {this.props.link &&
              <CustomLink link={this.props.link} className="nav-link btn btn-mdb-color btn-sm-block mt-4 noeffect" aria-label={this.props.title} >
                <FontAwesomeIcon icon={this.props.icon == "right" ? faChevronRight : faDownload} className="mr-2" />
                {this.props.linktext}
              </CustomLink>
              }

              {(this.props.ctalink && this.props.ctatext !== " ") && 
                <CustomLink link={this.props.ctalink} className="nav-link btn btn-mdb-color btn-sm-block mt-4 noeffect">
                  <FontAwesomeIcon icon={this.props.icon == "right" ? faChevronRight : faDownload} className="mr-2" />
                  {this.props.ctatext}
                </CustomLink>
              }
          </MDBCol>
        </MDBRow>
      </>
    )
  }
}
export default ColumnAlternatingButton